import { getIds } from "./getIds";

export const getPeriodDate = (date, withHour = true) => {
  const startDate = date ? `${date?.split("|")[0]}${withHour ? ` 00:00:00` : ``}` : undefined;
  const endDate = date ? `${date?.split("|")[1]}${withHour ? ` 23:59:59` : ``}` : undefined;

  return [startDate, endDate];
};

export const buildQueryParams = (
  user,
  projectIds,
  scopeType,
  technicianSelect,
  currentUser,
  projectsPeriodFilter
) => {
  const [startDate, endDate] = getPeriodDate(projectsPeriodFilter);
  const dateParams =
    startDate && endDate ? `&startDate=${startDate}&endDate=${endDate}` : '';

  const technicianIds =
    technicianSelect && Array.isArray(technicianSelect) && technicianSelect.length > 0
      ? `&tecId=${getIds(technicianSelect)}`
      : '';
  
    const normalizeSingleQuotes = (str) => {
    if (!str) return ''

    const cleaned = str.replace(/^'+|'+$/g, '')
    return `'${cleaned}'`
  }

  const isFalsyProjectId = (val) =>
  val === null ||
  val === undefined ||
  val === '' ||
  val === 'null' ||
  val === 'undefined'

  const projectsIdsOrScope = !isFalsyProjectId(projectIds)
    ? `projects=${projectIds}`
    : `scopeType=${scopeType}`;

  if (currentUser === 'USER_TEC') {
    const result = `${projectsIdsOrScope}&tecId=${user.id}${dateParams}`;
    return result;
  }

  if (currentUser === 'USER_MANAGER' || currentUser === 'USER_ADMIN') {
    const result = `${projectsIdsOrScope}${technicianIds}${dateParams}`;
    return result;
  }

  return dateParams;
};